<template>
  <div v-if="item.uid" class="rc-l-detail">
    <div class="rc-l-detail--top">
      <div class="container">
        <div class="row">
          <div class="col position-relative">
            <article class="rc-main-article">
              <!-- Warning isExpired (ends of rights || channel unsubscribe)-->
              <template v-if="isExpired(item)">
                <div class="rc-end-rights">
                  <div class="rc-end-rights--text">
                    <h2 class="h3">{{ $t("rights.end.title") }}</h2>
                    <!-- Verify if channel unsubscribe -->
                    <!-- <p v-if="channelUnsubscribe(item)">
                      {{ $t("rights.end.desc_channel") }}
                    </p> -->
                    <!-- End of rights -->
                    <p>
                      {{ $t("rights.end.desc") }}
                      <a :href="$t('nav.url.help_end_of_rights')">{{
                        $t("common.learn_more")
                      }}</a>
                    </p>
                    <!--If user not guest and item is in his favorites-->
                    <rc-btn
                      v-if="getUserUID && getFavorite(item.uid)"
                      variant="primary"
                      class="rc-btn-icon-text"
                      @click="removeFromFavorites(item)"
                    >
                      <RcIcon name="remove" scale="1"></RcIcon>
                      {{ $t("catalog.favorites.remove_from") }}</rc-btn
                    >
                  </div>
                </div>
              </template>
              <!-- If there is no valid screener-->
              <template v-else-if="hasNoScreener(item)">
                <div class="rc-media-wrapper">
                  <div class="ratio ratio-16x9">
                    <div class="rc-no-screener">
                      <div class="rc-no-screener--text">
                        {{ $t("catalog.no_screener") }}
                      </div>
                    </div>
                    <RcImgLazy
                      class="img-fluid w-100"
                      :src="imgThumbnail(item)"
                      alt=""
                      @error="imageUrlFallback"
                    ></RcImgLazy>
                  </div>
                </div>
              </template>
              <template v-else>
                <div id="rc-media" class="rc-media-wrapper">
                  <!--Accessibility key/value-->
                  <div class="rc-media-accessibility">
                    <rc-btn
                      v-if="isPlaying"
                      @click="onBtnAllyClick('pause')"
                      variant="primary"
                      size="lg"
                      >Pause</rc-btn
                    >
                    <rc-btn
                      v-else
                      @click="onBtnAllyClick('play')"
                      variant="primary"
                      size="lg"
                      >{{ $t("catalog.play") }}</rc-btn
                    >
                    <RcA11yPlayer />
                  </div>

                  <div class="ratio ratio-16x9">
                    <!-- videojs player -->
                    <RcVideojsPlayer
                      @onPlayerReady="onPlayerReady"
                      @play="onPlaybackStart"
                      @pause="onPlaybackPause"
                      @ended="onPlaybackEnded"
                      @timeupdate="onTimeUpdate"
                      :options="videoOptions"
                    />
                  </div>

                  <!-- rating -->
                  <RcRating
                    :uid="item.uid"
                    @change="ratingChanged"
                    :appear="showRating"
                    class="mt-3"
                  />
                </div>
              </template>

              <div
                class="rc-media-desc"
                :class="item.featured ? 'rc-is-featured' : ''"
              >
                <span v-if="item.featured" class="rc-ribbon">{{
                  $t("common.team_picks")
                }}</span>

                <header>
                  <h1 class="rc-title mb-2">{{ item.title }}</h1>
                  <div
                    class="rc-container-toolbar pb-2"
                    v-if="!isExpired(item)"
                  >
                    <div class="row g-0 align-items-center">
                      <div
                        :class="[
                          { 'col-auto': !getUserUID && !orgIsPublic },
                          'col'
                        ]"
                      >
                        <RcItemDetailToolbar
                          :item="item"
                          :options="toolbarOptions"
                        />
                      </div>

                      <div
                        class="col-12 col-sm-auto"
                        v-if="!getUserUID && !orgIsPublic"
                      >
                        <div class="rc-unlock-action">
                          <!-- Link Create your profile if not public library-->

                          <router-link
                            :to="toMarketCreateProfile"
                            class="rc-link-secondary"
                            >{{ $t(`nav.create_profile`) }}</router-link
                          >
                          {{ $t(`nav.create_profile_end`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </header>

                <div class="row rc-article-body">
                  <div :class="showGuides ? 'col-lg-8' : 'col-lg-9'">
                    <template v-if="lastChance(item)">
                      <div class="row g-0 rc-last-chance">
                        <div class="col-auto">
                          <RcIcon name="bell" scale="1.5" />
                        </div>
                        <div class="col">
                          <h2 class="h4">
                            {{ $t("rights.last_chance.title") }}
                          </h2>
                          <p>
                            {{ $t("rights.last_chance.desc") }}
                            {{
                              useDateFormats(item.owner.end_of_rights, "LL")
                            }}.
                            <a :href="$t('nav.url.help_end_of_rights')">{{
                              $t("common.learn_more")
                            }}</a>
                          </p>
                        </div>
                      </div>
                    </template>

                    <ul class="nav nav-tabs" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link active"
                          id="overviewTab"
                          data-bs-toggle="tab"
                          data-bs-target="#overviewTabPanel"
                          type="button"
                          role="tab"
                          aria-controls="overviewTabPanel"
                          aria-selected="true"
                        >
                          {{ $t("common.overview") }}
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link"
                          id="metadataTab"
                          data-bs-toggle="tab"
                          data-bs-target="#metadataTabPanel"
                          type="button"
                          role="tab"
                          aria-controls="metadataTabPanel"
                          aria-selected="false"
                        >
                          {{ $t("catalog.metadata") }}
                        </button>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        class="tab-pane fade show active"
                        id="overviewTabPanel"
                        role="tabpanel"
                        aria-labelledby="overviewTab"
                      >
                        <h2 class="visually-hidden">
                          {{ $t("common.overview") }}
                        </h2>

                        <ul class="list-group list-group-flush rc-list-data">
                          <li
                            class="list-group-item"
                            v-if="item.owner && getChannel(item.owner.uid)"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("common.channel") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <!--Subscribe-->
                                <router-link
                                  :to="{
                                    name: 'catalog.channels.detail',
                                    params: {
                                      uid: item.owner.uid,
                                      locale: $i18n.locale
                                    }
                                  }"
                                >
                                  {{ item.content_owner.name }}
                                </router-link>
                              </div>
                            </div>
                          </li>

                          <!-- Group type (new)-->
                          <li class="list-group-item" v-if="item.group_item">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>
                                  {{
                                    $tc(
                                      "catalog.group_type." +
                                        item.group_item.group_type +
                                        ".title",
                                      1
                                    )
                                  }}
                                </h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <router-link
                                  :to="{
                                    name: 'catalog.group.slug',
                                    params: {
                                      type: item.group_item.group_type,
                                      slug: item.group_item.slug,
                                      locale: $i18n.locale
                                    }
                                  }"
                                >
                                  {{ item.group_item.name }}</router-link
                                >
                              </div>
                            </div>
                          </li>

                          <li class="list-group-item" v-if="item.edition_name">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("catalog.edition") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <div>
                                  {{ item.edition_name }}
                                </div>
                              </div>
                            </div>
                          </li>

                          <li
                            class="list-group-item"
                            v-if="getTeamTypeAudience"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>
                                  {{
                                    $tc(
                                      "catalog.audience_type." +
                                        getTeamTypeAudience,
                                      2
                                    )
                                  }}
                                </h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                {{ getItemAudiencesLong(item) }}
                              </div>
                            </div>
                          </li>
                          <li class="list-group-item">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("common.duration") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <span
                                  aria-hidden="true"
                                  :title="
                                    useLocaleDuration(
                                      item.duration,
                                      $i18n.locale
                                    )
                                  "
                                >
                                  {{ useShortDuration(item.duration) }}
                                </span>
                                <span class="visually-hidden">
                                  {{
                                    useLocaleDuration(
                                      item.duration,
                                      $i18n.locale
                                    )
                                  }}
                                </span>
                              </div>
                            </div>
                          </li>
                          <li class="list-group-item">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("catalog.production_year") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                {{ item.year }}
                              </div>
                            </div>
                          </li>
                          <li
                            class="list-group-item"
                            v-if="item.close_captions"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("catalog.closed_captions") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                {{ $t("common.available") }}
                              </div>
                            </div>
                          </li>
                          <li class="list-group-item" v-if="item.overview">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>Description</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <div class="rc-summary">
                                  <RcReadMore :contentText="item.overview" />
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div
                        class="tab-pane fade"
                        id="metadataTabPanel"
                        role="tabpanel"
                        aria-labelledby="metadataTab"
                      >
                        <h2 class="visually-hidden">
                          {{ $t("catalog.metadata") }}
                        </h2>
                        <ul class="list-group list-group-flush rc-list-data">
                          <!-- Team -->
                          <li
                            class="list-group-item"
                            v-if="item.participants && item.participants.length"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("catalog.team") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <ul>
                                  <li
                                    v-for="(
                                      participant, index
                                    ) in item.participants"
                                    :key="index"
                                  >
                                    <template v-if="$i18n.locale == 'fr'">
                                      {{ participant.person }} ({{
                                        participant.role_fr
                                      }})
                                    </template>

                                    <template v-else>
                                      {{ participant.person }} ({{
                                        participant.role_en
                                      }})
                                    </template>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                          <!-- Language -->
                          <li class="list-group-item" v-if="item.language">
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("common.language") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <span v-if="item.language == 'French'">
                                  {{ $t("common.french") }}
                                </span>
                                <span v-else>
                                  {{ item.language }}
                                </span>
                              </div>
                            </div>
                          </li>
                          <!-- Original Broadcaster -->
                          <li
                            class="list-group-item"
                            v-if="item.original_broadcaster"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>
                                  {{ $t("catalog.original_broadcaster") }}
                                </h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                {{ item.original_broadcaster }}
                              </div>
                            </div>
                          </li>

                          <!-- Subjects -->
                          <li
                            class="list-group-item"
                            v-if="item.subjects && item.subjects.length"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $tc("catalog.subjects", 2) }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <ul>
                                  <li
                                    v-for="(subj, index) in nonGenericSubjects"
                                    :key="subj.uid"
                                    @click="resetFilters()"
                                  >
                                    <router-link
                                      :to="{
                                        name: 'catalog.subject.detail',
                                        params: {
                                          uid: subj.uid,
                                          subject: subj.subject,
                                          locale: $i18n.locale
                                        }
                                      }"
                                      >{{ subj.subject }}</router-link
                                    >
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>

                          <!-- Categories -->
                          <li
                            class="list-group-item"
                            v-if="uniqueCategories && uniqueCategories.length"
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("common.categories") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <ul>
                                  <li
                                    v-for="cat in uniqueCategories"
                                    :key="cat.uid"
                                  >
                                    <router-link
                                      :to="{
                                        name: 'catalog.category.detail',
                                        params: {
                                          locale: $i18n.locale,
                                          uid: cat.uid
                                        }
                                      }"
                                      >{{ cat.name }}</router-link
                                    >
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>

                          <!-- MARC Records -->
                          <li
                            class="list-group-item"
                            v-if="
                              roleIsAdmin || roleIsTeacher || roleIsLibraryUser
                            "
                          >
                            <div class="row align-items-start">
                              <div class="col-sm-4 col-md-3">
                                <h4>{{ $t("catalog.marc_record") }}</h4>
                              </div>
                              <div class="col-sm-8 col-md-9">
                                <ul class="d-flex">
                                  <li>
                                    <a
                                      :href="toMarcRecordsDisplay"
                                      target="_blank"
                                      class="btn btn-light btn-sm me-2"
                                      >{{ $t("common.display") }}
                                      <span class="visually-hidden">{{
                                        $t("common.new_window")
                                      }}</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      :href="toMarcRecordsDownload"
                                      class="btn btn-light btn-sm"
                                      :download="$t('catalog.marc_record')"
                                      >{{ $t("common.download") }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4" v-if="showGuides">
                    <!-- Teacher guides -->
                    <div class="rc-guide">
                      <h2 class="h3">
                        {{
                          $tc("catalog.teacher_guides", item.attachments.length)
                        }}
                      </h2>

                      <div class="list-group">
                        <!--LIST CAS PARTICULIER-->
                        <a
                          class="list-group-item"
                          v-for="file in item.attachments"
                          :key="file.uid"
                          :href="file.download"
                          :target="
                            file.attachment_type == 'pdf' ? '_blank' : '_self'
                          "
                        >
                          <div class="row g-0">
                            <div class="col-auto">
                              <div v-if="file.attachment_type == 'pdf'">
                                <img :src="icons.pdf" alt="pdf" />
                              </div>
                              <div v-else-if="file.attachment_type == 'doc'">
                                <img :src="icons.doc" alt="doc" />
                              </div>
                              <div v-else-if="file.attachment_type == 'xls'">
                                <img :src="icons.xls" alt="xls" />
                              </div>
                              <div v-else-if="file.attachment_type == 'ppt'">
                                <img :src="icons.ppt" alt="ppt" />
                              </div>
                            </div>
                            <div class="col">
                              <div>{{ file.name }}</div>
                              <div class="rc-type">
                                {{ file.attachment_type }}
                                <span
                                  v-if="file.attachment_type == 'pdf'"
                                  class="visually-hidden"
                                  >{{ $t("a11y.link.new_window") }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <!-- Up Next Desktop -->
            <!-- todo fix aside -->
            <aside
              class="rc-up-next d-none d-lg-block"
              v-if="upNext.data.results.length > 1"
            >
              <section>
                <h2 class="h3">
                  {{ $tc("catalog.up_next", 1) }}
                </h2>
                <div @click="upNextClicked">
                  <transition name="fade" mode="out-in">
                    <RcGridUnit :item="upNext.data.results[getInitialSlide]" />
                  </transition>
                </div>
              </section>
            </aside>

            <!-- up next fallback -->
            <!-- todo fix aside -->
            <aside
              class="rc-up-next d-none d-lg-block"
              v-else-if="fromSameShow"
            >
              <section>
                <h2 class="h3">
                  {{ $tc("catalog.up_next", 1) }}
                </h2>

                <div @click="upNextClicked">
                  <transition name="fade" mode="out-in">
                    <RcGridUnit :item="fromSameShow" />
                  </transition>
                </div>
              </section>
            </aside>

            <!-- loader -->
            <!-- todo fix aside -->
            <aside class="rc-up-next d-none d-lg-block" v-else>
              <section>
                <RcGridSkeletonUnit />
              </section>
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Up Next Mobile/Tablet -->
    <section
      class="rc-carousel-hooper rc-up-next-mobile d-lg-none"
      v-if="upNext.data.results.length > 1"
      @click="upNextClicked"
    >
      <div class="container">
        <div class="rc-carousel-hooper--header">
          <h2 class="h3">
            {{ $tc("catalog.up_next", upNext.data.results.length) }}
          </h2>
        </div>
      </div>
      <RcCarousel :settings="upNextSettings" :items="upNext" />
    </section>

    <!-- related courses -->
    <section class="rc-section-links" v-if="coursesByProvinceName.length > 1">
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-sm-12">
            <h2>{{ $t("common.keep_exploring") }}</h2>
          </div>
          <div class="col-md-12 col-lg-10 col-xl-9">
            <ul class="rc-list-link-btn">
              <li
                v-for="course in coursesByProvinceName.slice(0, maxCourses)"
                :key="course.uid"
                @click="resetFilters()"
              >
                <router-link
                  class="btn btn-plum-darker"
                  :to="{
                    name: 'catalog.courses.detail',
                    params: {
                      uid: course.uid,
                      // name: course.name || '',
                      locale: $i18n.locale
                    }
                  }"
                >
                  <div v-orphan>
                    {{ course.name }}
                  </div>
                  <div v-orphan v-if="course.grade" class="rc-sub-title">
                    {{ course.grade }}
                  </div>
                </router-link>
              </li>
            </ul>

            <template v-if="coursesByProvinceName.length > maxCourses">
              <rc-btn
                v-if="!isShowMoreCoursesOpen"
                variant="link"
                class="text-white mt-3 btn-show-more"
                @click="isShowMoreCoursesOpen = !isShowMoreCoursesOpen"
              >
                <span>
                  <span aria-hidden="true">{{ $t("common.show_more") }}</span>
                  <span class="visually-hidden">{{
                    $t("common.show_more_courses")
                  }}</span
                  ><rc-icon name="chevronDownBold" scale=".6"></rc-icon
                ></span>
              </rc-btn>

              <div id="show-more-courses" v-if="isShowMoreCoursesOpen">
                <ul class="rc-list-link-btn">
                  <li
                    v-for="course in coursesByProvinceName.slice(maxCourses)"
                    :key="course.uid"
                    @click="resetFilters()"
                  >
                    <router-link
                      class="btn btn-plum-darker"
                      :to="{
                        name: 'catalog.courses.detail',
                        params: {
                          uid: course.uid,
                          // name: course.name || '',
                          locale: $i18n.locale
                        }
                      }"
                    >
                      <div v-orphan>
                        {{ course.name }}
                      </div>
                      <div v-orphan v-if="course.grade" class="rc-sub-title">
                        {{ course.grade }}
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>

              <rc-btn
                v-if="isShowMoreCoursesOpen"
                variant="link"
                class="text-white mt-3 btn-show-less"
                @click="isShowMoreCoursesOpen = !isShowMoreCoursesOpen"
              >
                <span aria-hidden="true">{{ $t("common.show_less") }}</span>
                <span class="visually-hidden">{{
                  $t("common.show_less_courses")
                }}</span
                ><rc-icon name="chevronUpBold" scale=".6"></rc-icon>
              </rc-btn>
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- from autosuggest -->
    <section
      class="rc-carousel-hooper"
      v-if="getTeamTypeAudience == 'level' && autoSuggest && autoSuggest.length"
    >
      <h2 class="text-center">Keep exploring (suggestions)</h2>

      <RcCarousel
        :settings="{ infiniteScroll: false, rtl: false }"
        :items="suggestCarouselItems"
        :omitUID="item.uid"
      />
    </section>

    <!--More from channel-->
    <RcCarouselCompound
      v-if="item.owner && getChannel(item.owner.uid)"
      :lazy="false"
      :title="$t('common.more_from_this_channel')"
      :omitUID="item.uid"
      :payload="{
        owner: item.owner.uid,
        page_size: 8,
        ordering: '-published_on',
        facet: 'owner'
      }"
      @loaded="commitUpNext"
      :to="{
        name: 'catalog.channels.detail',
        params: {
          uid: item.owner.uid
        }
      }"
    />

    <RcCarouselCompound
      v-if="item.group_item"
      :lazy="false"
      :title="$t('catalog.group_type.' + item.group_item.group_type + '.more')"
      :omitUID="item.uid"
      :payload="{
        group_type: item.group_item.group_type,
        group_slug: item.group_item.slug,
        page_size: 8,
        ordering: '-published_on',
        facet: 'group_slug'
      }"
      @loaded="commitUpNext"
      :to="{
        name: 'catalog.group.slug',
        params: {
          type: item.group_item.group_type,
          slug: item.group_item.slug,
          locale: $i18n.locale
        }
      }"
    />
  </div>
  <div v-else>
    <!-- <pre>{{ jsonLD }}</pre> -->
    <RcItemSEO :item="jsonLD" />
  </div>
</template>

<script>
import Config from "#/config";
import store from "#/stores";
import i18n from "#/locales";

import { mapState, mapActions, mapGetters } from "vuex";
import {
  ITEM_GET,
  ITEM_SET_USER_FILTER,
  ITEM_SET_FILTER_PARAMS,
  TRACK_UP_NEXT,
  SET_UP_NEXT_LIST,
  GET_JSON_LD
} from "@/libvue/apps/catalog/items/actions";

import { navMixin } from "#/routes/mixins";
import { videojsMixin } from "@/libvue/apps/catalog/mixins/videojsMixin";
import { favoritesMixin } from "@/libvue/apps/catalog/favorites/mixins";
import { catalogItemMixin } from "@/libvue/apps/catalog/mixins/itemMixin";

import { GET_FAVORITE } from "@/libvue/apps/catalog/favorites/actions";
import { POST_RATING } from "@/libvue/components/rating/actions";

import { groupBy } from "lodash";
import RcIcon from "@/libvue/components/icons/Base.vue";
import RcReadMore from "@/libvue/components/readMore/ReadMore.vue";
import RcCarousel from "@/libvue/apps/catalog/items/Carousel.vue";
import RcGridSkeletonUnit from "@/libvue/apps/catalog/items/GridSkeletonUnit.vue";
import RcImgLazy from "@/libvue/components/image/ImageLazy.vue";

import RcGridUnit from "@/libvue/apps/catalog/items/GridUnit.vue";
import RcCarouselCompound from "@/libvue/apps/catalog/items/CarouselCompound.vue";
import RcRating from "@/libvue/components/rating/Rating.vue";
import RcA11yPlayer from "#/pages/catalog/components/A11yPlayer.vue";
import RcItemDetailToolbar from "@/libvue/apps/catalog/items/DetailToolbar.vue";
import RcItemSEO from "#/pages/catalog/components/ItemSEO.vue";
import {
  useLocaleDuration,
  useShortDuration
} from "@/libvue/composables/durations";
import { useDateFormats } from "@/libvue/composables/formats";

import RcVideojsPlayer from "@/libvue/components/player/videojsPlayer.vue";
import icPDF from "#/assets/img/icons/ic_pdf.svg";
import icXLS from "#/assets/img/icons/ic_xls.svg";
import icDOC from "#/assets/img/icons/ic_doc.svg";
import icPPT from "#/assets/img/icons/ic_ppt.svg";
import fallbackImg from "#/assets/img/fallback.svg";

export default {
  name: "RcCatalogItemDetail",
  setup() {
    return { useLocaleDuration, useShortDuration, useDateFormats };
  },
  components: {
    RcIcon,
    RcGridUnit,
    RcGridSkeletonUnit,
    RcCarousel,
    RcCarouselCompound,
    RcRating,
    RcA11yPlayer,
    RcVideojsPlayer,
    RcItemDetailToolbar,
    RcReadMore,
    RcItemSEO,
    RcImgLazy
  },
  mixins: [navMixin, videojsMixin, favoritesMixin, catalogItemMixin],
  data() {
    return {
      isShowMoreCoursesOpen: false,
      maxCourses: 8,
      showUpNext: true,
      showRating: false,
      apiHost: Config.apiHost(),
      icons: {
        pdf: icPDF,
        doc: icDOC,
        ppt: icPPT,
        xls: icXLS
      }
      // videoOptions: {
      //   language: this.$i18n.locale,
      //   autoplay: false,
      //   controls: true,
      //   width: 900,
      //   sources: [],
      //   poster: "",
      //   playbackRates: [0.5, 0.75, 1, 1.5, 2],
      //   userActions: {
      //     hotkeys: true
      //   }
      // }
    };
  },
  computed: {
    ...mapState({
      profile: (state) => state.auth.user,
      item: (state) => state.items.detail.data,
      itemsBy: (state) => state.items.by,
      autoSuggest: (state) =>
        state.items.auto.data?.suggest?.auto_complete[0].options,
      upNext: (state) => state.items.upNext,
      jsonLD: (state) => state.items.seo.data
    }),
    ...mapGetters([
      "getTeamProvinceFromCurricula",
      "getTeamTypeAudience",
      "getUserUID",
      "getChannel",
      "getFavorite",
      "roleIsTeacher",
      "roleIsLibraryUser",
      "roleIsStudent",
      "roleIsAdmin",
      "orgIsPublic"
    ]),

    showGuides() {
      return !this.roleIsStudent && this.item.attachments?.length;
    },
    nonGenericSubjects() {
      return this.item.subjects?.filter((s) => !s.is_generic);
    },
    uniqueCategories() {
      return this.item.categories?.filter(
        (v, i, a) => a.findIndex((t) => t.uid === v.uid) === i
      );
    },
    coursesByProvince() {
      return groupBy(this.item.courses, "province");
    },
    coursesByProvinceName() {
      return (
        this.item.courses?.filter((cours) => {
          return cours.province === this.getTeamProvinceFromCurricula[0];
        }) || []
      );
    },
    curriculaByProvinceName() {
      const courses = this.item.courses?.filter((cours) => {
        return cours.province === this.getTeamProvinceFromCurricula[0];
      });
      return courses?.filter(
        (v, i, a) =>
          a.findIndex((t) => t.curriculum_uid === v.curriculum_uid) === i
      );
    },
    screenerContentMetas() {
      const metas = [
        this.item.group_item ? `show : ${this.item.group_item.name}` : null,
        this.item.season ? `season : ${this.item.season}` : null,
        this.item.episodes ? `episodes : ${this.item.episodes}` : null,
        this.item.title ? `title : ${this.item.title}` : null
      ];

      return metas.filter(Boolean).join(" | ");
    },
    suggestCarouselItems() {
      return { data: { results: this.autoSuggest.map((a) => a._source) } };
    },
    getInitialSlide() {
      const foundIndex = this.upNext.data.results.findIndex(
        (x) => x.uid == this.item.uid
      );

      return this.upNext.data.results.length == foundIndex + 1
        ? 0
        : foundIndex + 1;
    },
    upNextSettings() {
      return {
        rtl: false,
        infiniteScroll: false,
        initialSlide: this.getInitialSlide,

        breakpoints: {
          1400: {
            itemsToShow: 5.07
          },
          1200: {
            itemsToShow: 4.57
          },
          992: {
            itemsToShow: 3.7
          },
          768: {
            itemsToShow: 3.5
          },
          576: {
            itemsToShow: 2.25
          },
          0: {
            itemsToShow: 1.2
          }
        }
      };
    },
    toMarcRecordsDisplay() {
      return `${this.apiHost}/marc/items/${this.item.uid}/view`;
    },
    toMarcRecordsDownload() {
      return `${this.apiHost}/marc/items/${this.item.uid}/download`;
    },
    fromSameShow() {
      let sameShow = [];
      if (this.item.group_item) {
        sameShow =
          this.itemsBy?.group_slug[
            this.item.group_item.slug
          ]?.data?.results?.filter((i) => i.uid !== this.item.uid) || [];
      }

      return sameShow.length
        ? sameShow[Math.floor(Math.random() * sameShow.length)]
        : null;
    },
    toolbarOptions() {
      return {
        display: {
          permalink: true,
          bookmarks: Boolean(this.getUserUID),
          playlists: Boolean(this.getUserUID) && !this.roleIsStudent,
          segments: Boolean(this.getUserUID) && !this.roleIsStudent,
          sharingHelpText: this.$t("catalog.teacher_guides_notice")
        },
        sources: this.videoOptions.sources
      };
    }
  },

  methods: {
    ...mapActions({
      get: ITEM_GET
    }),
    imageUrlAlt(event) {
      event.target.src = fallbackImg;
    },
    resetFilters() {
      this.$store.commit(ITEM_SET_USER_FILTER, {
        reset: true
      });

      this.$store.commit(ITEM_SET_FILTER_PARAMS, {
        reset: true
      });
    },
    setRecentlyViewed(data) {
      // get and set recently viewed from localStorage
      const recentlyViewed = JSON.parse(
        localStorage.getItem("recently-viewed")
      );
      if (recentlyViewed) {
        const found = recentlyViewed.findIndex((x) => x.uid == data.uid);
        if (found >= 0) {
          recentlyViewed.splice(found, 1);
        }
        if (recentlyViewed.length == 16) {
          recentlyViewed.pop();
        }
        recentlyViewed.unshift(data);
        localStorage.setItem("recently-viewed", JSON.stringify(recentlyViewed));
      } else {
        localStorage.setItem("recently-viewed", JSON.stringify([data]));
      }
    },
    upNextClicked() {
      this.$store.commit(TRACK_UP_NEXT);
      this.showUpNext = false;
      setTimeout(() => {
        this.showUpNext = true;
      }, 400);
    },
    ratingChanged(rating) {
      this.$store.dispatch(POST_RATING, {
        item: this.item.uid,
        score: rating,
        role: this.profile.role
      });
    },
    commitUpNext(data) {
      if (this.upNext.data.results.length <= 1) {
        this.$store.commit(SET_UP_NEXT_LIST, data.results);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters.getProfile.user_uid) {
      store.dispatch(GET_FAVORITE, to.params.uid).catch(() => "");
    }

    store
      .dispatch(ITEM_GET, to.params)
      .then((data) => {
        document.title =
          data.title + i18n.global.t("pageMeta.default.endTitle");

        next((vm) => {
          vm.initPlayer(vm, data);
          if (data.status == "published") {
            vm.setRecentlyViewed(data);
          }
        });
      })
      .catch((error) => {
        switch (error.response?.status) {
          case 401:
            next((vm) => {
              vm.$store.dispatch(GET_JSON_LD, { url: to.path });
            });
            break;
          case 402:
            next({
              name: "403",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;
          case 403:
            next({
              name: "403",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;
          case 404:
            next({
              name: "not.found",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;

          default:
            next();
            break;
        }
      });
  },
  beforeRouteUpdate(to, from, next) {
    store.dispatch(GET_FAVORITE, to.params.uid).catch(() => "");
    store
      .dispatch(ITEM_GET, to.params)
      .then((data) => {
        document.title =
          data.title + i18n.global.t("pageMeta.default.endTitle");

        if (!this.isExpired(this.item) && !this.hasNoScreener(this.item)) {
          this.initPlayer(this, this.item);
        }
        this.setRecentlyViewed(data);
        next();
      })
      .catch((error) => {
        next();
        switch (error.response?.status) {
          case 401:
            next((vm) => {
              vm.$store.dispatch(GET_JSON_LD, { url: to.path });
            });
            break;
          case 402:
            next({
              name: "403",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;
          case 403:
            next({
              name: "403",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;
          case 404:
            next({
              name: "not.found",
              params: { error: error.response.data, locale: i18n.global.locale }
            });
            break;

          default:
            next();
            break;
        }
      });
  },
  mounted() {
    //Pinned
    this.observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
      { threshold: [1.0] }
    );
    if (document.getElementById("rc-media")) {
      this.observer.observe(document.getElementById("rc-media"));
    }
  },

  beforeUnmount() {
    this.observer = null;
  }
};
</script>

<style lang="scss"></style>
